import React from 'react';
import { useLocation } from 'react-router-dom';
import { businessGuideContent } from './data.js';
import '../assests/CSS/BusinessGuide.css';

const BusinessServicesGuide = () => {
  const location = useLocation();
  const searchData = location.state?.searchData || {};
  const selectedCountry = searchData.location || businessGuideContent.defaultCountry;
  const content = businessGuideContent.getContent(selectedCountry);

  return (
    <div className="business-services-container">
      <div className="business-services-header">
        <div className="title-container">
          <h1>
            <img 
              src={content.flag} 
              alt={`${selectedCountry} Flag`} 
              className="country-flag" 
              onError={(e) => {
                e.target.onerror = null; 
                e.target.src = businessGuideContent.countries[businessGuideContent.defaultCountry].flag;
              }}
            />
            {content.title}
          </h1>
        </div>
        <h2>{content.subtitle}</h2>
        <p className="description">{content.description}</p>
      </div>
      
      <div className="service-categories">
        {content.sections.map((section, index) => (
          <div key={index} className="service-card">
            <div className="service-title-container">
              <div className="service-icon">
                <img 
                  src={section.icon} 
                  alt={section.title}
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = businessGuideContent.countries[businessGuideContent.defaultCountry].sections[index]?.icon;
                  }}
                />
              </div>
              <h3>{section.title}</h3>
            </div>
            <p>{section.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessServicesGuide;